/**
* @Description 文件功能说明：账户 table 组件
* @Author
* @Time 2021/6/4
**/

/* HTML */
<template>
    <div :class="{'table-item-box': true, 'max-box': !showBoxFlag}">
        <section style="height: 100%;">
            <!--查询工具条-->
            <el-col style="text-align: left;">
                <el-form :inline="true" :model="filters" ref="filters">
                    <el-form-item>查询条件：</el-form-item>
                    <el-form-item prop="groupId">
                        <TreeSelect :data="userGroups" :selectTree="groupSelectTree" @setSelectVal="setSelectVal" ref="treeSelect"/>                        
                    </el-form-item>
                    <el-form-item prop="keyword">
                        <el-input v-model="filters.keyword" placeholder="请输入人员姓名/编号" clearable @keyup.enter.native="researchUsers">
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="researchUsers"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item style="float: right;margin-right: 0px;">
<!--                        <el-dropdown split-button type="primary" @click="call(0)" trigger="click" >
                            <i class="el-icon-link"></i> 一键呼叫
                            <el-dropdown-menu slot="dropdown" trigger="click">
                                <el-dropdown-item  icon="el-icon-link" @click.native="call(1)">呼叫所有人</el-dropdown-item>

                            </el-dropdown-menu>
                        </el-dropdown>-->
                        <el-dropdown split-button type="primary" @click="unbound" trigger="click" >
                            <i class="el-icon-link"></i> 刷卡解绑
                            <el-dropdown-menu slot="dropdown" trigger="click">
                                <el-dropdown-item  icon="el-icon-link" @click.native="unboundBatch">批量解绑</el-dropdown-item>
                                <el-dropdown-item  icon="el-icon-delete" @click.native="deleteBatch">批量删除</el-dropdown-item>
                                <el-dropdown-item v-if="false" icon="el-icon-download" @click.native="download">下载模板</el-dropdown-item>
                                <el-dropdown-item v-if="false">
                                    <el-upload
                                        ref="uploadUser"
                                        accept=".xlsx,.xls"
                                        :auto-upload="true"
                                        :show-file-list="false"
                                        :before-upload="beforeUpload"
                                        :on-success="uploadSuccess"
                                        :on-error="uploadError"
                                        :action="upload.uploadUrl"
                                        :headers="upload.myHeaders"
                                    >
                                        <i class="el-icon-upload2"></i>批量上传
                                    </el-upload>
                                </el-dropdown-item>
                                <el-dropdown-item v-if="false" icon="el-icon-download" @click.native="exportData()">数据导出</el-dropdown-item>
<!--                                <el-dropdown-item  icon="el-icon-upload" @click.native="syncBatch()">同步用户</el-dropdown-item>-->
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-button type="primary" icon="el-icon-connection" trigger="click" @click="addUser">新增人员</el-button>
                        
                    </el-form-item>
                </el-form>
            </el-col>
            <!-- 表格 -->
            <el-table :data="users"
                      @sort-change="changeSort"
                      ref="multipleTable"
                      stripe
                      :class="{'table': true, 'no-pagination': false}" style="height: calc(100% - 100px);">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="portrait" label="头像" width="80px" :show-overflow-tooltip="true">
                	<template slot-scope="scope">
                        <el-popover v-if="scope.row.portrait!=null&&scope.row.portrait!=''"
                        	:title="scope.row.userName"
                        	placement="right" trigger="hover" >
                            <el-image slot="reference" :src="scope.row.portrait" style="width: 40px;height: 40px;display: block;border-radius: 50%;text-align: center;background: #c8c8cd;"></el-image>
                            <el-image :src="scope.row.portrait" ></el-image>
                        </el-popover>
                	</template>
                </el-table-column>
                <el-table-column prop="user_name" label="姓名" min-width="120px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
                  <template slot-scope="scope">
                    <i v-if="scope.row.sex==1" class="el-icon-male" ></i>
                    <i v-else class="el-icon-female"></i>
                    <i v-if="scope.row.followLevel==1" class="el-icon-star-on"></i>
                    <span style="white-space: nowrap;" :title="'姓名：' + scope.row.userName + '\n性别：' + (scope.row.sex==1?'男':'女') + '\n' + (scope.row.followLevel==1?'重点关注对象':'')">{{scope.row.userName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="id_card" label="编号" min-width="150px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
                  <template slot-scope="scope">
                    <span style="white-space: nowrap;" :title="scope.row.idCard">{{scope.row.idCard}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="group_id" label="分组" min-width="100px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
                	<template slot-scope="scope">
                		<span style="white-space: nowrap;" :title="scope.row.groupName">{{scope.row.groupName}}</span>
                	</template>
                </el-table-column>
                <el-table-column prop="phone" label="手机号" min-width="100px">
                	<template slot-scope="scope">
                		<span style="white-space: nowrap;" :title="'+' + scope.row.phoneCode + ' ' + scope.row.phone">{{ (scope.row.phone==''||scope.row.phone==null)?'':(scope.row.phone)}}</span>
                	</template>
                </el-table-column>
                <el-table-column prop="tagId" label="绑定标签" min-width="130px">
                	<template slot-scope="scope">
                		<span style="white-space: nowrap;" :title="scope.row.tagId">{{scope.row.tagId}}</span>
                	</template>
                </el-table-column>
                <el-table-column label="操作" width="180px">
                    <template slot-scope="scope">
                      <el-button-group>
                        <span  class="el-icon-edit" size="mini" @click="()=>{editRow(scope.row, scope.$index)}" trigger="click"  title="编辑"> 编辑</span>
                        <span  class="el-icon-connection" size="mini" @click="()=>{bindingRow(scope.row, scope.$index)}" trigger="click" title="绑定标签" v-if="!scope.row.tagId || scope.row.tagId==''"> 绑定</span>
                        <span  class="el-icon-link" size="mini" @click="()=>{unboundRow(scope.row, scope.$index)}" trigger="click" title="解除绑定" v-if="scope.row.tagId && scope.row.tagId!=''"> 解绑</span>
                      </el-button-group>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页工具条-->
            <Pagination
                :currentPage="pagination.currentPage"
                :total="pagination.total"
                :pageSize="pagination.limit"
                :background="true"
                @handleSizeChangeSub="handleSizeChangeSub"
                @handleCurrentChangeSub="handleCurrentChangeSub"
            />

            <!-- 添加账户 -->
            <UserDialog ref="userDialog" :userGroups="userGroups" :visibleFlag="false" @setTotal="setTotal" @setRow="setRow" />

            <!-- 用户健康信息 -->
            <UserHealthyDialog ref="userHealthyDialog" />

            <!-- Excel上传 -->
            <UploadDialog ref="uploadDialog"
                          :uploadUrl="upload.saveUrl"
                          :previewTitle="upload.previewTitle"
                          :previewData="upload.previewData"
                          :showSerialNumber="false"
                          @reSearch = "researchUsers"/>

            <!-- 导出数据 -->
            <el-table :data="exportDatas" id="out-table" style="display: none;">
                <el-table-column prop="groupName" label="组名">
                    <template slot-scope="scope">
                        {{scope.row.groupName}}
                    </template>
                </el-table-column>
                <el-table-column prop="idCard" label="编号">
                    <template slot-scope="scope">
                        {{scope.row.idCard}}
                    </template>
                </el-table-column>
                <el-table-column prop="userName" label="姓名">
                    <template slot-scope="scope">
                        {{scope.row.userName}}
                    </template>
                </el-table-column>
                <el-table-column prop="sex" label="性别">
                    <template slot-scope="scope">
                        {{scope.row.sex==1?'男':'女'}}
                    </template>
                </el-table-column>
                <el-table-column prop="duty" label="职务">
                    <template slot-scope="scope">
                        {{scope.row.duty}}
                    </template>
                </el-table-column>
                <el-table-column prop="phone" label="手机号">
                    <template slot-scope="scope">
                        {{scope.row.phone}}
                    </template>
                </el-table-column>
                <el-table-column prop="tagId" label="绑定标签">
                    <template slot-scope="scope">
                        {{scope.row.tagId}}
                    </template>
                </el-table-column>
                <el-table-column prop="follow" label="重点关注">
                    <template slot-scope="scope">
                        {{scope.row.followLevel==1?'是':''}}
                    </template>
                </el-table-column>
                <el-table-column prop="remarks" label="备注">
                    <template slot-scope="scope">
                        {{scope.row.remarks}}
                    </template>
                </el-table-column>
            </el-table>

        </section>
    </div>
</template>

<script>
    import ApiUser from '@/request/api-user'
    import TreeSelect from '@/components/TreeSingleSelect.vue'
    import UserDialog from './UserDialog.vue'
    import Pagination from '@/components/Pagination.vue'
    import store from "@/store";
    import UploadDialog from './UploadDialog'
    import GlobalFun from "@/global/global-function";
    import UserHealthyDialog from "./UserHealthyDialog";
    export default {
        /**
         * @Des 组件名
         * @Auth
         * @Date 2021/6/4
         */
        name: "UserTable",
        /**
         * @Des 数据接收类型
         * @Auth
         * @Date 2021/6/4
         */
        props: {
            // 用户组信息集合
            userGroups: {
                type: Array,
                default: function (){
                    return [];
                }
            },
            /**
             * @Des 展示box
             * @Auth
             * @Date 2021/6/5
             */
            showBoxFlag: {
                type: Boolean,
                default: function (){
                    return true
                }
            },
        },
        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/6/4
         */
        components: {
            // 选择树组件
            TreeSelect,
            // 账户弹窗组件
            UserDialog,
            // 分页组件
            Pagination,
            // 动态表格
            UploadDialog,
            // 用户健康信息
            UserHealthyDialog
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 2021/6/4
         */
        data() {
            return {

                /**
                 * @Des 分页数据
                 * @Auth
                 * @Date 2021/6/4
                 */
                pagination:{
                    total: 0,
                    startNum: 0,
                    limit: 20,
                    currentPage: 1
                },
                /**
                 * @Des 查询数据
                 * @Auth
                 * @Date 2021/6/4
                 */
                filters: {
                    typeId: '',
                    groupId: '',
                    keyword: '',
                    orderBy: {
                        "follow_level": "desc"
                    },
                    sortOrders: [
                        "ascending",
                        "descending"
                    ],
                    sortable: 'custom'
                },
                // 账户信息集合
                users: [],
                /**
                 * @Des 用户组树数据
                 * @Auth
                 * @Date 2021/6/4
                 */
                groupSelectTree:{
                    placeholder: '请选择人员组',
                    keywordFilter: false,
                    showBox: false,
                    childBox: false,
                    parentBox: false,
                },
                /**
                 * @Des 上传属性
                 * @Auth Zhangbin
                 * @Date 17:17 2021/4/30
                 */
                upload:{
                    myHeaders: {
                        token: store.state.token,
                        lang: store.state.lang,
                        loginDevice: store.state.loginDevice
                    },
                    previewTitle:[],
                    previewData:[],
                    uploadUrl: ApiUser.uploadUrlApi,// + '?projectId=' + store.state.currentProjectId,
                    saveUrl: ApiUser.addUserApi
                },
                sexIcon: {
                    '1': '/static_dazzle/images/icon_user_1.png',
                    '2': '/static_dazzle/images/icon_user_2.png',
                },
                exportDatas: []
            }
        },
        computed: {
        },
        /**
         * @Des 监听
         * @Auth
         * @Date 2021/6/4
         */
        watch: {
            /**
             * @Des 分页监听
             * @Auth
             * @Date 2021/6/4
             */
            pagination: {
                handler(newVal, oldVal){
                    this.searchUsers();
                },
                immediate: true,
                deep:true,
            }
        },
        /**
         * @Des 初始化加载
         * @Auth
         * @Date 2021/6/4
         */
        mounted(){
            // 查询账户信息
            this.searchUsers();
            GlobalFun.base64Image(this.sexIcon[1], data => {
                this.sexIcon[1] = data;
            });
            GlobalFun.base64Image(this.sexIcon[2], data => {
                this.sexIcon[2] = data;
            });
        },
        /**
         * @Des 方法定义
         * @Auth
         * @Date 2021/6/4
         */
        methods: {
            /**
             * 重新搜搜
             * */
            researchUsers(){
                this.pagination.total = 0;
                this.pagination.startNum = 0;
                this.pagination.currentPage = 1;
                this.searchUsers();
            },
            /**
             * @Des 查询账户信息
             * @Auth
             * @Date 2021/6/4
             */
            searchUsers(){
                this.$request.postJsonRequest(ApiUser.searchUserApi,{
                    // typeId: this.filters.typeId==''?null:this.filters.typeId,
                    groupId: this.filters.groupId==''?null:this.filters.groupId,
                    keyword: this.filters.keyword,
                    // projectId: this.$store.state.currentProjectId,
                    orderBy: this.filters.orderBy,
                    total: this.pagination.total,
                    startNum: this.pagination.startNum,
                    limit: this.pagination.limit,
                }).then(result => {
                    this.pagination.total = result.total;
                    this.users = result.rows;
                    // console.log(result.rows)
                }).catch(error => {
                    console.error('查询人员信息异常', ApiUser.searchUserApi, error);
                })
            },
            /**
             * @Des 查询用户信息, 并导出
             * @Auth
             * @Date 2021/6/4
             */
            exportData(){
                this.$request.postJsonRequest(ApiUser.exportApi,{
                    // typeId: this.filters.typeId==''?null:this.filters.typeId,
                    groupId: this.filters.groupId==''?null:this.filters.groupId,
                    keyword: this.filters.keyword,
                    // projectId: this.$store.state.currentProjectId,
                    orderBy: this.filters.orderBy,
                }).then(result => {
                    this.exportDatas = [];
                    if(result.total > 0){
                        this.exportDatas = result.rows;
                    }
                    // console.log(this.exportDatas);
                    // 就绪后 执行
                    this.$nextTick(() => {
                      GlobalFun.exportExcel(document.querySelector("#out-table"),'人员信息.xlsx');
                    });
                      }).catch(error => {
                          console.error('导出用户信息异常', ApiUser.exportApi, error);
                      })
                  },
            /**
             * @Des 新增账户
             * @Auth
             * @Date 2021/6/4
             */
            addUser() {
            	this.$refs.userDialog.openDialog('新增人员', '保存添加', 'add');
            },
            /**
             * @Des 编辑账户
             * @Auth
             * @Date 2021/6/21
             */
            editRow(row, index) {
            	this.$refs.userDialog.openDialog('编辑人员', '保存修改', 'edit', row, index);
            },
            /**
             * @Des 删除账户
             * @Auth
             * @Date 2021/6/21
             */
            deleteRow(row, index){
                this.$confirm(
                  '确认删除【'+ row.userName +'】？','询问',
                  {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnClickModal : false,
                    type: 'warning'
                  }
                ).then(_ => {
                  // 删除账户 交互
                  this.requestDelete([row.userId]);
                }).catch(_ => {
                  //console.log('cancel')
                });
                    },

            /**
             * @Des 批量删除
             * @Auth
             * @Date 2021/6/21
             */
            deleteBatch(){
                let data = this.$refs.multipleTable.selection;
                const ids = [];
                data.forEach((row, index) => {
                    ids.push(row.userId);
                })
                if(ids.length == 0){
                    this.$message({
                        message: '请选择要删除的数据！',
                        type: 'warning',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    return false;
                }
                this.$confirm(
                    '确认批量删除用户吗？','询问',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal : false,
                        type: 'warning'
                    }
                ).then(_ => {
                    // 删除账户 交互
                    this.requestDelete(ids);
                }).catch(_ => {
                    //console.log('cancel')
                });
            },
            /**
             * @Des 删除账户 交互
             * @Auth
             * @Date 2021/6/21
             */
            requestDelete(userIds) {
            	this.$request.postJsonRequest(ApiUser.deleteUserApi,{
                    userIds: userIds,
                    // projectId: this.$store.state.currentProjectId
                }).then(result => {
                    if(result.code == 0){
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        // 改变总数
                        this.setTotal(0);

                    }else{
                        this.$message({
                            message: '正在绑定标签的用户不能删除，请解除绑定后再删除！',
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                }).catch(error => {
                    console.error('删除人员异常', ApiUser.deleteUserApi, error);
                })
            },

            /**
             * 绑定
             * */
            bindingRow(row, index){
                this.$refs.userDialog.openDialog('绑定标签', '绑定标签', 'binding',row, index);
            },

            /**
            * @Description 同步用户
            * @Param
            * @Auth jsh
            * @Date 2021/10/28 6:06 下午
            */
            syncBatch() {
                this.$request.postJsonRequest(ApiUser.syncBatchUser,{
                    typeFlag: 4,
                    // projectId: this.$store.state.currentProjectId
                }).then(result => {
                    if (result.code == 0) {
                        this.$message({
                            message: '同步成功',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    } else {
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                }).catch(error => {
                    console.error('同步用户异常', ApiUser.syncBatchUser, error);
                })
            },

            /**
             *  批量解绑
             * */
            unboundBatch(){
                let data = this.$refs.multipleTable.selection;
                const ids = [];
                data.forEach((row, index) => {
                    ids.push(row.userId);
                })
                if(ids.length == 0){
                    this.$message({
                        message: '请选择要解绑的数据！',
                        type: 'warning',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    return false;
                }
                this.$confirm(
                    '确认批量解绑用户吗？','询问',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal : false,
                        type: 'warning'
                    }
                ).then(_ => {
                    // 解绑用户 交互
                    this.$request.postJsonRequest(ApiUser.unboundUserApi,{
                        userIds: ids,
                        // projectId: this.$store.state.currentProjectId
                    }).then(result => {
                        if(result.code == 0){
                            this.$message({
                                message: '解绑成功',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                        this.searchUsers();
                    }).catch(error => {
                        console.error('批量解绑异常', ApiUser.unboundUserApi, error);
                    })
                }).catch(_ => {
                    //console.log('cancel')
                });
            },

            /**
             * 解除绑定
             * */
            unbound(){
                this.$refs.userDialog.openDialog('解绑标签','解绑标签', 'unbound');
            },

            /**
             * @Des 解绑
             * @Auth
             * @Date 2021/6/21
             */
            unboundRow(data,index){
                this.$confirm(
                    '确认要解绑标签【'+data.tagId+'】吗？','询问',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal : false,
                        type: 'warning'
                    }
                ).then(_ => {
                    this.$request.postJsonRequest(ApiUser.unboundUserApi,{
                        userIds: [data.userId],
                        // projectId: this.$store.state.currentProjectId
                    }).then(result => {
                        if(result.code == 0){
                            this.$message({
                                message: '解绑成功',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            // 改变行值
                            data.tagId = '';
                            this.setRow(data, index);

                        }else{
                            this.$message({
                                message: '解绑失败',
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                    }).catch(error => {
                        console.error('解绑异常', ApiUser.unboundUserApi, error);
                    })
                }).catch(_ => {
                    //console.log('cancel')
                });
            },

            /**
             * 健康信息
             * */
            healthy(row, index){
                // console.log(row, index);
                this.$refs.userHealthyDialog.openDialog('【' + row.groupName + "-" + row.userName + '】的健康状况', row.userId);
            },

            /**
             * 关注
             * */
            follow(row, index){
                // console.log(row, index);
                let followLevel = 1;
                if(row.followLevel && row.followLevel == 1){
                    // 已经关注，取消关注
                    followLevel = 0;
                }
                this.$request.postJsonRequest(ApiUser.updateFollowLevel,{
                    userId: row.userId,
                    followLevel: followLevel,
                    // projectId: this.$store.state.currentProjectId
                }).then(result => {
                    if(result.code == 0){
                        this.$message({
                            message: followLevel==1?'关注成功':"取消关注成功",
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        row.followLevel = followLevel;
                    }else{
                        this.$message({
                            message: result.message,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                }).catch(error => {
                    console.error('关注异常', ApiUser.updateFollowLevel, error);
                })
            },


            /**
             * @Des 改变总数
             * @Auth
             * @Date 2021/6/21
             */
            setTotal(val){
                this.pagination.total = val;
                if(val == 0){
                    this.pagination.currentPage = 1;
                    this.pagination.startNum = 0;
                }
                // 查询list
                this.searchUsers();
            },
            /**
             * @Des 更新列表
             * @Auth
             * @Date 2021/6/21
             */
            setRow(row, index){
                this.users[index].duty = row.duty;
                this.users[index].groupId = row.groupId;
                this.users[index].groupName = row.groupName;
                this.users[index].idCard = row.idCard;
                this.users[index].phoneCode = row.phoneCode;
                this.users[index].phone = row.phone;
                this.users[index].portrait = row.portrait;
                this.users[index].remarks = row.remarks;
                this.users[index].sex = row.sex;
                this.users[index].tagId = row.tagId;
                this.users[index].typeId = row.typeId;
                this.users[index].userId = row.userId;
                this.users[index].userName = row.userName;
                this.users[index].followLevel = row.followLevel;
            },

            /**
             * @Des 选择值改变
             * @Auth
             * @Date 2021/6/4
             */
            setSelectVal(val){
                if(val && val.id){
                    if(val.parentId == 0){
                        // this.filters.typeId = val.id.replace("T","");
                        this.filters.groupId = '';
                    }else{
                        // this.filters.typeId = val.parentId.replace("T","");
                        this.filters.groupId = val.id;
                    }
                    this.$refs['treeSelect'].setSelectVal(val);
                }else{
                    this.filters.typeId = '';
                    this.filters.groupId = '';
                    this.$refs['treeSelect'].setSelectVal();
                }
                // 改变总数
				this.setTotal(0);
            },

            /**
             * @Des 当前页数据改变
             * @Auth
             * @Date 2021/6/4
             */
            handleCurrentChangeSub(val){
                this.pagination.currentPage = val;
                this.pagination.startNum = this.pagination.limit * (val-1);
            },
            /**
             * @Des 页长度改变
             * @Auth
             * @Date 2021/6/4
             */
            handleSizeChangeSub(val){
                this.pagination.limit = val;
                this.pagination.currentPage = 1;
                this.pagination.startNum = 0;
            },
            /**
             * @Des 下载模板
             * @Auth
             * @Date 2021/6/4
             */
            download(){
                // 下载模板

				// 文件名
				let fileName = '人员上传模板.xlsx';
				// 资源文件下载 至本地
				GlobalFun.downloadFile(ApiUser.userUploadModel, fileName);

            },
            /**
             * @Des 上传之前的处理
             * @Auth Zhangbin
             * @Date 17:20 2021/4/30
             */
            beforeUpload(file){
                // 上传之前
                // console.log(file)
                this.upload.previewTitle = [];
                this.upload.previewData = [];
                let extension = file.name.substring(file.name.lastIndexOf('.')+1);
                let size = file.size/1024/1024;
                // console.log(extension, size)
                if(extension !== 'xlsx') {
                    this.$message.warning('只能上传后缀是.xlsx的文件');
                }
                if(size > 10) {
                    this.$message.warning('文件大小不得超过10M');
                }
            },

            /**
             * @Des 上传成功后的处理
             * @Auth Zhangbin
             * @Date 17:20 2021/4/30
             */
            uploadSuccess(res, file, fileList) {
                // 上传成功
                // console.log(res, file, fileList);
                // console.log(this.upload.fileType)
                if(res.code == 0){
                    // 返回数据
                    // console.log(res.data)
                    // 显示人员列表信息
                    this.upload.previewTitle.push({
                        label: '组名',
                        prop: 'groupNameSpan',
                        width: '80px'
                    });
                    this.upload.previewTitle.push({
                        label: '编号',
                        prop: 'idCardSpan',
                        width: '150px'
                    });
                    this.upload.previewTitle.push({
                        label: '姓名',
                        prop: 'userNameSpan',
                        width: '80px'
                    });
                    this.upload.previewTitle.push({
                        label: '性别',
                        prop: 'sexNameSpan',
                        width: '80px'
                    });
                    this.upload.previewTitle.push({
                        label: '手机号',
                        prop: 'phoneSpan',
                        width: '100px'
                    });
                    this.upload.previewTitle.push({
                        label: '职务',
                        prop: 'dutySpan',
                        width: '80px'
                    });
                    this.upload.previewTitle.push({
                        label: '绑定标签',
                        prop: 'tagIdSpan',
                        width: '130px'
                    });
                    this.upload.previewTitle.push({
                        label: '备注',
                        prop: 'remarksSpan',
                        width: '100px'
                    });
                    this.upload.previewTitle.push({
                        label: '信息',
                        prop: 'messageSpan',
                    })
                    res.data.forEach((row, index) => {

                        let _row = {
                            groupName: row.groupName,
                            groupId: row.groupId,
                            // typeId: row.typeId,
                            portrait: row.sex==1?this.sexIcon[1]:this.sexIcon[2],
                            userName: row.userName,
                            sexName: row.sex==1?'男':'女',
                            sex: row.sex,
                            idCard: row.idCard,
                            duty: row.duty,
                            remarks: row.remarks,
                            tagId: row.tagId,
                            phone: row.phone,
                            code: row.code,
                            message: row.message,
                            disabled: row.code==0?false:true,
                            checked: row.code==0?true:false,
                        };

                        let _row_ = {};
                        for (var i in _row) {
                        	// 外围添加 span
                        	_row_[i + 'Span'] = this.surroundSpan(_row[i]==null?"":_row[i]);
                        };

                        this.upload.previewData.push(Object.assign({}, _row, _row_));
                    });
                    if(this.upload.previewData.length > 0){
                        //弹出预览
                        this.$refs.uploadDialog.openDialog("人员上传预览", "确定上传");
                    }
                    // console.log(res.data)
                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg ,
                        dangerouslyUseHTMLString: true
                    });
                }
            },

            /**
             * @Des 上传失败后的处理
             * @Auth Zhangbin
             * @Date 17:20 2021/4/30
             */
            uploadError(err, file, fileList) {
                // 上传失败
                this.$message({
                    type: 'error',
                    message: err.msg ,
                    dangerouslyUseHTMLString: true
                });
            },

            /**
             * @Des 外围添加 span
             * @Auth
             * @Date 2021/7/5
             */
            surroundSpan(value) {
            	return '<span style="white-space: nowrap;" title="'+ value +'">'+ value +'</span>';
            },
            /**
             * 改变排序
             * */
            changeSort(data){
                let prop = data.prop;
                let order = data.order;
                if(order == null){
                    order = this.filters.orderBy[prop];
                }else{
                    order = order.replace("ending", "");
                }
                if(order != null){
                    this.filters.orderBy = {};
                    this.filters.orderBy[prop] = order;
                }
                this.researchUsers();
            },
            /**
             * @Des 批量删除
             * @Auth
             * @Date 2021/6/21
             */
            call(type){
              if(type == 0){
                let data = this.$refs.multipleTable.selection;
                let ids = [];
                data.forEach((row, index) => {
                  ids.push(row.userId);
                })
                if(ids.length == 0){
                  this.$message({
                    message: '请选择要呼叫的对象！',
                    type: 'warning',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                  });
                  return false;
                }
                this.$confirm(
                    '确认要呼叫所选人员吗？','询问',
                    {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      closeOnClickModal : false,
                      type: 'warning'
                    }
                ).then(_ => {
                  // 删除账户 交互
                  let params = {
                    // projectId: this.$store.state.currentProjectId,
                    userIds: ids,
                    all: 0,
                  }
                  this.callObject(params);
                }).catch(_ => {
                  //console.log('cancel')
                });

              }else{
                this.$confirm(
                    '确认要呼叫所有人员吗？','询问',
                    {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      closeOnClickModal : false,
                      type: 'warning'
                    }
                ).then(_ => {
                  // 呼叫所有人员 交互
                  let params = {
                    // projectId: this.$store.state.currentProjectId,
                    all: 1
                  }
                  this.callObject(params);
                }).catch(_ => {
                  //console.log('cancel')
                });
              }


            },
            callObject(params){
              this.$request.postJsonRequest(ApiUser.callApi,params).then(result => {
                if(result.code == 0){
                  this.$message({
                    message: '发送呼叫成功',
                    type: 'success',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                  });
                }
              }).catch(error => {
                console.error('发送呼叫指令异常', ApiUser.deleteUserApi, error);
              })
            }
        },
    }
</script>
/* JS */

/* CSS */
<style lang="scss" scoped>
	.button1{
        position: absolute;
        left: -170px;
        width: 155px;
        height: 46px;
    }
    
</style>



// WEBPACK FOOTER //
// src/components_pages/User/UserTable.vue